import { uniqueId } from 'lodash';
import isNumber from 'lodash/isNumber';

import { TOKEN_TYPE } from 'common/util/filter/types';
import { CellRenderer } from 'plugins/types';
import { EVENT_CATEGORY_FIELD, SchemaField } from 'schemas';
import { TooltipPlacement, TruncateWithTooltip } from '../components';

import './EventDetailsCellRenderer.scss';

export const EventDetailsCellRenderer: CellRenderer = ({ row, fieldId, schemaFields }) => {
  const category = String(row[EVENT_CATEGORY_FIELD] ?? '');
  const field = schemaFields?.[fieldId];
  const detailsFields = field?.relatedFieldsMap?.[category];

  const fieldsToDisplay = detailsFields
    ?.map((attribute: string) => {
      const field = schemaFields?.[attribute];
      if (field) {
        return {
          ...field,
          id: attribute,
        };
      }
      return null;
    })
    .filter((item: SchemaField | null) => !!item);

  const renderDetailsField = (fieldToDisplay: SchemaField | null) => {
    const fieldId = fieldToDisplay?.id;
    const label = fieldToDisplay?.label;
    const value = fieldId && row?.[fieldId];

    if (!fieldToDisplay || !value) {
      return null;
    }

    const valueType = isNumber(value) ? TOKEN_TYPE.NUMBER : TOKEN_TYPE.STRING;

    return (
      <div className="EventDetailsCellRenderer__Field" key={fieldId}>
        <TruncateWithTooltip
          id={uniqueId(`EventDetailsCellRenderer-${label}-`)}
          text={label?.toString() ?? ''}
          placement={TooltipPlacement.BOTTOM}
          classNames="EventDetailsCellRenderer__Field__Label"
        />
        <div data-term-field={fieldId} data-term-value-type={valueType}>
          <TruncateWithTooltip
            id={uniqueId(`EventDetailsCellRenderer-${value}-`)}
            text={value?.toString() ?? ''}
            placement={TooltipPlacement.BOTTOM}
            classNames="EventDetailsCellRenderer__Field__Value"
          />
        </div>
      </div>
    );
  };

  return <div className="EventDetailsCellRenderer">{fieldsToDisplay?.map(renderDetailsField)}</div>;
};
